export const MEMBERSHIP_PRODUCT_NAMES: readonly string[] = [
  "telehealth-medtier-membership-sync",
  "telehealth-medtier-membership-async",
];

// TODO(UPSELL-2245): Replace with the final user-facing membership name once defined.
export const MEMBERSHIP_DISPLAY_NAME = "PLACEHOLDER";

export type MembershipMedication = {
  name: string;
  genericName: string;
  dosage: string;
  imageSrc: string;
};

// TODO(UPSELL-2245): Return the medication connected to the membership once billing confirms how they're modeled.
export function getMembershipMedication(): MembershipMedication | undefined {
  return undefined;
}
